import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("sr_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("sr_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sr_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, referralCode = null) => {
    const payload = { name, email, password };
    if (referralCode) payload.referral_code = referralCode;
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("sr_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("sr_token");
    localStorage.removeItem("sr_admin_token");
    setUser(null);
  };

  /** Switch session to another user (admin only). The current admin token is
   * stashed in `sr_admin_token` so the admin can return with `endImpersonation`. */
  const impersonate = async (targetUserId) => {
    const { data } = await api.post(`/admin/users/${targetUserId}/impersonate`);
    const currentToken = localStorage.getItem("sr_token");
    if (currentToken) localStorage.setItem("sr_admin_token", currentToken);
    localStorage.setItem("sr_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const endImpersonation = async () => {
    const adminToken = localStorage.getItem("sr_admin_token");
    if (!adminToken) return null;
    localStorage.setItem("sr_token", adminToken);
    localStorage.removeItem("sr_admin_token");
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const isImpersonating = typeof window !== "undefined" && !!localStorage.getItem("sr_admin_token");

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, impersonate, endImpersonation, isImpersonating }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
